<template>
  <v-card
    v-bind:class="{ archived: pagebreak.archived, hidden: (!viewArchived && pagebreak.archived) }"
    style="margin-bottom:20px;"
  >
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editpagebreak.conditional_question_id = arguments[0].question_id; editpagebreak.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    <v-toolbar
      dense
      flat
      color="rgba(0,0,0,0.09)"
      style="position:relative;"
    >
        <a
          roll="button"
          class="handle"
          style="float:left;"
        >
          <v-icon small left>drag_handle</v-icon>
        </a>
        <b style="margin-right: 50px;">Page Break</b>
        <v-chip 
          outline
          color="grey"
          small
          v-if="pagebreak.web_only"  
        >
          Web Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="pagebreak.pdf_only"  
        >
          PDF Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="conditional_part"  
        >
          Conditional
        </v-chip>
        <ArchiveButton
          style="float:right;position:absolute;right:45px;top:12px;"
          :archived="pagebreak.archived"
          @restore="restore()"
          @archive="archive()"
        />
        <a
          roll="button"
          class="question-edit-button"
          style="float:right;position:absolute;right:15px;top:12px;"
          @click="editing=true"
        >
          <v-icon small color="blue">edit</v-icon>
        </a>
        <div 
          v-if="editing"
          style="float:right;position:absolute;top:0px;right:5px;"
        >
          <v-btn
            color="blue"
            dark
            small
            @click="save"
          >
            Save
          </v-btn>
          <v-btn
            small
            @click="editing=false;editHTML=false"
          >
            Cancel
          </v-btn>
        </div>
    </v-toolbar>
    <div
      v-if="editing"
      style="position: relative;min-height: 30px;background: rgba(0,0,0,0.02);"
    >
      <v-alert
        :value="true"
        type="info"
        style="margin:10px;"
      >
        Page Breaks have no configurable options, except for part visibility.
      </v-alert>
      <div
        class="adv_settings"
      >
        <span>
          Additional Settings
        </span>
        <v-expand-transition>
          <div
            style="padding: 10px 0 15px 0;"
          >
            <v-layout 
              row 
              wrap 
            >
              <v-flex xs12 sm4>
                <v-checkbox
                  v-model="editpagebreak.web_only"
                  label="Hide on PDF (Web Only)"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-checkbox
                  v-model="editpagebreak.pdf_only"
                  label="PDF Only"
                  persistent-hint
                  hint="Do not show on Web"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-checkbox
                  v-model="conditional_part"
                  label="Conditional Form Part"
                  persistent-hint
                  hint="Display part depending on answer to question"
                />
              </v-flex>
            </v-layout>
            <v-layout 
              row 
              wrap 
              v-if="conditional_part"
            >
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editpagebreak.conditional_question_id"
                  label="Question ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editpagebreak.conditional_fieldtype_id"
                  label="Fieldtype ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editpagebreak.conditional_value"
                  label="Conditional Value"
                  style="margin-right: 10px;"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editpagebreak.conditional_apply_pdf"
                  label="Apply to PDF"
                  persistent-hint
                  hint="Hide from PDF if part fails condition"
                />
              </v-flex>
              <v-flex sm12>
                <v-btn 
                  dense
                  @click="fieldSelecting = true"
                >
                  Select a field
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-expand-transition>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import ArchiveButton from './ArchiveButton'
import FormTemplateFieldSelector from '../FormTemplateFieldSelector.vue'

export default {
  name: 'FormTemplatePageBreak',
  props: [ 'partId', 'newPart' ],
  components: {
    ArchiveButton,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editpagebreak: {},
      editing: false,
      loading: false,
      displayAdditional: false,
      value: '',
      editHTML: false,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  created () {
    this.editing = !(this.pagebreak.id)
    this.conditional_part = (this.pagebreak.conditional_question_id)
    this.$nextTick(() => {
      if (this.newPart) {
        this.save()
      }
    })
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
      'fieldTypeById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived'
    ]),
    pagebreak: function () {
      return this.partById(this.partId) || this.newPart
    }
  },
  watch: {
    editing (val) {
      if (val) {
        this.editpagebreak = JSON.parse(JSON.stringify(this.pagebreak))
      } else {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'savePagebreak'
    ]),
    save () {
      this.loading = true
      if(!this.conditional_part){
        this.editpagebreak.conditional_question_id = null
        this.editpagebreak.conditional_fieldtype_id = null
        this.editpagebreak.conditional_apply_pdf = false
        this.editpagebreak.conditional_value = ""
      }
      this.savePagebreak(this.editpagebreak)
        .then(pagebreak => {
          this.editing = false
          this.$emit('save', pagebreak)
          this.loading = false
        })
    },
    archive () {
      this.loading = true
      this.pagebreak.archived = true
      this.savePagebreak(this.pagebreak)
      .then(pagebreak => {
        this.loading = false
        this.$emit('save', pagebreak)
      })
    },
    restore () {
      this.loading = true
      this.pagebreak.archived = false
      this.savePagebreak(this.pagebreak)
      .then(pagebreak => {
        this.loading = false
        this.$emit('save', pagebreak)
      })
    }
  }
}
</script>

<style scoped>
  .html >>> p {
    margin: 0 !important;
  }

  .adv_settings {
      padding:0 10px;
      padding: 0 25px 0 25px;
      border-top: 1px solid rgba(0,0,0,0.1)
  }

  .hidden {
    display: none !important;
  }

</style>